import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiFillCaretDown, AiOutlineRadarChart, AiTwotoneExperiment } from "react-icons/ai";


function HeaderVert(props) {

    const [btnClicked, setBtnClicked] = useState(false);
    const [isOverBtn, setIsOverBtn] = useState(false);
    const [isOverList, setIsOverList] = useState(false);

    const handleMouseEnterBtn = (event) => {
        setIsOverBtn(true)
    }
    const handleMouseLeaveBtn = (event) => {
        setIsOverBtn(false)
    }

    const handleMouseEnterList = (event) => {
        setIsOverList(true)
    }
    const handleMouseLeaveList = (event) => {
        setIsOverList(false)
    }

    const navigate = useNavigate()

    return ( 
        <div className='w-screen grid grid-cols-1
        bg-white text-gray-500 bg-opacity-95
          p-6 space-y-0
          text-base'>

            <div className='flex justify-center items-center py-4 hover:font-semibold'
                 onClick={()=>setBtnClicked(!btnClicked)}
                 onMouseEnter={handleMouseEnterBtn}
                 onMouseLeave={handleMouseLeaveBtn}>
                <button className=''>Products</button>
                <AiFillCaretDown className={`text-md mt-0.5 duration-300 ${((isOverBtn || isOverList || btnClicked) ) && 'rotate-180'}`}/> 
            </div>
            
                {(isOverBtn || isOverList || btnClicked) && 
                <div className='space-y-2'>
                    <hr />
                    <div className='text-left space-y-3 text-sm text-gray-400 flex flex-col justify-center items-center'
                        onMouseEnter={handleMouseEnterList}
                        onMouseLeave={handleMouseLeaveList}>                        
                        <button className='w-28 ml-12 hover:font-semibold flex items-center hover:text-[#bb16a3]'
                                onClick={()=>{navigate('/simulator'); props.closeVertMenu()}}><AiOutlineRadarChart className='text-lg mr-1'/> Simulator</button>
                        <button className='w-28 ml-12 hover:font-semibold flex items-center hover:text-[#bb16a3]'
                                onClick={()=>{navigate('/blender'); props.closeVertMenu()}}><AiTwotoneExperiment className='text-lg mr-1'/> Blender</button>
                        
                    </div>
                    <hr />
                </div>
                }
            <button className='py-4 hover:font-semibold'>Resources</button>
            <button className='py-4 hover:font-semibold'>Get a Demo</button>
            <button className='py-4 hover:font-semibold'>Contact</button>
            <hr />
            <button className='pt-8 pb-4 hover:font-semibold'>Log in</button>
        </div>
     );
}

export default HeaderVert;